
/**
 * 마지막 메시지 역할
 * @nullable
 */
export type ConversationDetailAllOfLastMessageRole = typeof ConversationDetailAllOfLastMessageRole[keyof typeof ConversationDetailAllOfLastMessageRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationDetailAllOfLastMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
